/*
  Calculating amount, adjusted and down payment for FHA loan type
  Formula => 	Amount		= SP * LTV / 100
*/
export const getSellerAmountCONV = (formData) => {
  let amount = (parseFloat(formData.salesPrice) * parseFloat(formData?.loanInfoMeta?.conventionalPercent)) / 100;
  // let adjusted = amount + (amount * parseFloat(formData.MIP)) / 100;
  let adjusted = amount;

  return {
    amount: amount,
    adjusted: adjusted,
  };
}


export const calculateNetSheet = (formData) => {
  // Helper to convert currency string → number
  const parseCurrency = (value) =>
    parseFloat(String(value || "").replace(/[^0-9.-]+/g, "")) || 0;

  // Ensure numeric math
  const salesPrice = parseCurrency(formData.salesPrice);
  const loanBalance = parseCurrency(formData.loanBalance || formData.mortgageAmount);
  const closingCosts = parseCurrency(formData.closingCosts);
  const homeWarranty = parseCurrency(formData.homeWarrantyAmount);

  // Commission in percentage of sales price
  const commissions =
    ((parseFloat(formData.listingAgentSplit || 0) +
      parseFloat(formData.buyerAgentSplit || 0)) /
      100) *
    salesPrice;

  const totalDeductions = loanBalance + closingCosts + commissions + homeWarranty;
  const netAtClose = salesPrice - totalDeductions;

  return {
    salesPrice,
    loanBalance,
    closingCosts,
    commissions,
    homeWarranty,
    netAtClose,
  };
};


export function calSellerMustNet(data) {
  //sum of loansToBePaidBalance1 loansToBePaidBalance2 loansToBePaidBalance3
  let sellerMustNet = safeNum(data?.sellerMustNet);
  let loansToBePaidBalance1 = safeNum(data?.loanInfoMeta?.loansToBePaidBalance1);
  let loansToBePaidBalance2 = safeNum(data?.loanInfoMeta?.loansToBePaidBalance2);
  let loansToBePaidBalance3 = safeNum(data?.loanInfoMeta?.loansToBePaidBalance3);

  // Sum value keys from loanInfoMeta
  let loanInfoMetaTotal = loansToBePaidBalance1 + loansToBePaidBalance2 + loansToBePaidBalance3;
  let sellerWantTotal = sellerMustNet + loanInfoMetaTotal;

  let salesprice = (sellerWantTotal * 1.08)

  return Number(salesprice.toFixed(2));
}

const safeNum = v => {
  if (v === null || v === undefined || v === '') return 0;
  if (typeof v === 'number') return v;
  const s = String(v).replace(/[^0-9.-]+/g, '');
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
};

/**
 * computeAllTotals
 * Calculate and return a `totalClosingMeta` object containing aggregated totals
 * for various sections. Does not mutate input.
 *
 * Keys returned in totalClosingMeta:
 * - titleSettlementMetaTotal
 * - sellerClosingCostMetaTotal
 * - compensationMetaTotal
 * - closingCostMetaTotal
 * - sellerOtherCostMetaTotal
 */
export function computeAllTotals(data) {

  const asArray = (v) => {
    if (Array.isArray(v)) return v;
    if (v && typeof v === 'object') return Object.values(v);
    return [];
  };

  // titleSettlementMeta total (owners + escrow + lenders)
  const t = data?.titleSettlementMeta || {};
  const titleSettlementMetaTotal = safeNum(t.ownersTitleAmount) + safeNum(t.escrowSettlementAmount) + safeNum(t.lendersTitleAmount);

  // Sum keys from sellerClosingCostMeta
  // If an item has key === 'transfer_tax', use its `amount` (computed dollar) for totals
  const sellerClosingCostMetaTotal = asArray(data?.sellerClosingCostMeta).reduce((s, it) => {
    try {
      if (!it) return s;
      const key = (it?.key || '').toString();
      if (key === 'transfer_tax') return s + safeNum(it?.amount);
      return s + safeNum(it?.value);
    } catch (e) {
      return s;
    }
  }, 0);

  // Sum value keys from compensationMeta
  const compensationMetaTotal = asArray(data?.compensationMeta).reduce((s, it) => s + safeNum(it?.value), 0);
  

  // Sum value keys from closingCostMeta
  const closingCostMetaTotal = asArray(data?.closingCostMeta).reduce((s, it) => s + safeNum(it?.total), 0);

  // Sum value keys from sellerOtherCostMeta, add check if unit key have value % then use amount else use value
  const sellerOtherCostMetaTotal = asArray(data?.sellerOtherCostMeta).reduce((s, it) => {
    const amount = safeNum(it?.amount);
    const value = safeNum(it?.value);
    return s + (it?.unit === '%' ? amount : value);
  }, 0);

  //sum of loansToBePaidBalance1 loansToBePaidBalance2 loansToBePaidBalance3
 // const loansToBePaidBalance1 = safeNum(data?.loanInfoMeta?.loansToBePaidBalance1);
 // const loansToBePaidBalance2 = safeNum(data?.loanInfoMeta?.loansToBePaidBalance2);
  //const loansToBePaidBalance3 = safeNum(data?.loanInfoMeta?.loansToBePaidBalance3);

  // Sum value keys from loanInfoMeta
  //const loanInfoMetaTotal = loansToBePaidBalance1 + loansToBePaidBalance2 + loansToBePaidBalance3;
  //console.log("Loan Info Meta Total:", loanInfoMetaTotal);

 // const estimatedTaxProrations = safeNum(data?.loanInfoMeta?.estimatedTaxProrations);
  //console.log("Estimated Tax Prorations:", estimatedTaxProrations);

  const otherCostMetaTotal = asArray(data?.otherCostMeta).reduce((s, it) => s + safeNum(it?.value), 0);

  const sellerCostsTotal = titleSettlementMetaTotal + sellerClosingCostMetaTotal + compensationMetaTotal + closingCostMetaTotal;

  const otherCostsTotal = sellerOtherCostMetaTotal + otherCostMetaTotal;

  const allCostsTotal = sellerCostsTotal + otherCostsTotal;

 // const sellerMustNet = (safeNum(data?.salesPrice) || 0) - allCostsTotal - estimatedTaxProrations - loanInfoMetaTotal;
  const sellerMustNet =  allCostsTotal;

  const totalClosingMeta = {
    titleSettlementMetaTotal,
    sellerClosingCostMetaTotal,
    compensationMetaTotal,
    closingCostMetaTotal,
    sellerOtherCostMetaTotal,
    sellerCostsTotal,
    otherCostsTotal,
    allCostsTotal,
    sellerMustNet
  };

  return totalClosingMeta;
}

/**
 * updateDerivedFields
 * Given a form data snapshot, return a new object with updated
 * compensationMeta, otherCostMeta and closingCostMeta arrays where
 * values and totals are computed from the sales price and rates/types.
 * This function does NOT write into RHF; it returns the updated data so
 * callers can decide how to persist (setValue or fieldArray.replace).
 */
export function updateDerivedFields(data) {
  const safeNum = v => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;
    const s = String(v).replace(/[^0-9.-]+/g, '');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  };

  const asArray = (v) => {
    if (Array.isArray(v)) return v.slice();
    if (v && typeof v === 'object') return Object.values(v);
    return [];
  };

  const salesPrice = safeNum(data?.salesPrice);

  // derive a loanAmount fallback: mortgageAmount or loanAmount or loanInfoMeta balances or salesPrice
  const loanAmount = safeNum(data?.loanInfoMeta?.adjusted);

  const computeFromRate = (rateRaw, baseAmount) => {
    const r = safeNum(rateRaw);
    return (baseAmount * (r / 100)) || 0;
  };
  
  const computeRateFromValue = (valueRaw, baseAmount) => {
    const v = safeNum(valueRaw);
    return (v / baseAmount) * 100 || 0;
  };

  // compensationMeta: rate => value (sales * rate/100)
  const compensationMeta = asArray(data?.compensationMeta).map((it) => {
    try {      
      const rateRaw = it?.rate  ?? 0;
      //const valueRaw = it?.value ?? 0;
      const valueRaw = 0;
      const v = safeNum(valueRaw);
      if(v > 0) {
        return { ...it, rate: computeRateFromValue(valueRaw, salesPrice) , value: valueRaw };
      }else{
        const amount = computeFromRate(rateRaw, salesPrice);
        return { ...it, value: typeof it.value === 'string' ? (amount ? amount.toFixed(2) : '0.00') : amount };
      }
    } catch (e) {
      return it;
    }
  });

  // otherCostMeta: same behavior (e.g., discount)
  const otherCostMeta = asArray(data?.otherCostMeta).map((it) => {
    try {
      const rateRaw = it?.rate ?? it?.value ?? 0;
      const amount = computeFromRate(rateRaw, loanAmount);
      return { ...it, value: typeof it.value === 'string' ? (amount ? amount.toFixed(2) : '0.00') : amount };
    } catch (e) {
      return it;
    }
  });

  // closingCostMeta: compute item.total based on its type and right-hand value
  const closingCostMeta = asArray(data?.closingCostMeta).map((it) => {
    try {
      const typeVal = (it?.type || '').toString();
      // prefer rate, then value, then total
      const rawVal = it?.value ?? it?.total ?? 0;
      const num = safeNum(rawVal);

      let computed = 0;
      if (/%\s*sale|sale price|sale/i.test(typeVal)) {
        computed = (salesPrice * (num / 100)) || 0;
      } else if (/%\s*loan|loan/i.test(typeVal)) {
        computed = (loanAmount * (num / 100)) || 0;
      } else {
        // Flat fee or unknown: treat the numeric value as flat amount
        computed = num;
      }

      // Store numeric total (rounded to 2 decimals when appropriate)
      const total = Number.isFinite(computed) ? Number(Number(computed).toFixed(2)) : 0;
      return { ...it, total };
    } catch (e) {
      return it;
    }
  });

  const sellerClosingCostMeta = asArray(data?.sellerClosingCostMeta).map((it) => {
    try {
     /// const typeVal = (it?.type || '').toString();
      const rateRaw = it?.rate ?? it?.value ?? 0;
      // Special handling for transfer tax: rate is per-mille (‰), use /1000
      const key = (it?.key || '').toString();
      if (key === 'transfer_tax') {
        const rate = safeNum(rateRaw);
        const amount = Number.isFinite(salesPrice * (rate / 1000)) ? salesPrice * (rate / 1000) : 0;
        const rounded = Number.isFinite(amount) ? Number(Number(amount).toFixed(2)) : 0;
        return { ...it, amount: rounded };
      }
      //const amount = computeFromRate(rateRaw, salesPrice);
      return { ...it, amount: it?.value ?? 0 };
    } catch (e) {
      return it;
    }
  });

  return {
    compensationMeta,
    otherCostMeta,
    closingCostMeta,
    sellerClosingCostMeta
  };
}

export const getSellerEstimatedTax = (estimatedClosingDate, annualPropertyTax, data1Proration, calc = "seller") => {

  if (!estimatedClosingDate || !annualPropertyTax || !Object.keys(data1Proration).length) {
    console.warn("Missing required data for tax calculation");
    return { estimatedTaxProrations: 0.00 };
  }

  // Extract date info
  const { month, year, days } = getDated(estimatedClosingDate);

  // Month mapping (1-based → string keys)
  const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
  const currentMonth = monthNames[month - 1];

  if (!currentMonth || typeof data1Proration[0][currentMonth] === "undefined") {
    console.warn("Invalid or missing proration month:", currentMonth);
    return { estimatedTaxProrations: 0.0 };
  }

  // Get prorations for current month directly
  const prorations = parseFloat(data1Proration[0][currentMonth] || 0);

  // Compute estimated proration
  const daysLeftInMonth = Math.abs(prorations) + days;
  const perDayTax = annualPropertyTax / 360; // assuming 360-day year
  let estimatedTaxProrations = perDayTax * daysLeftInMonth;

  // Adjust for negative proration
  if (prorations < 0) {
    estimatedTaxProrations = -estimatedTaxProrations;
  }

  return {
    estimatedTaxProrations: Number(estimatedTaxProrations.toFixed(2)),
    currentMonth,
    year,
    daysLeftInMonth,
    perDayTax,
  };
};

function getDated(currentDate) {
  const d1 = new Date(currentDate);

  if (isNaN(d1)) {
    console.warn("Invalid date in getDated:", currentDate);
    return { dated: 0, month: 0, year: 0, days: 0 };
  }

  const dated = d1.getDate();
  const month = d1.getMonth() + 1;
  const year = d1.getFullYear();

  // Adjust day for February or 31st
  let adjustedDate = dated;
  if (month === 2 && dated >= 28) adjustedDate = 30;
  if (dated === 31) adjustedDate = 30;

  return {
    dated: adjustedDate,
    month,
    year,
    days: dated,
  };
}

/**
 * calculateAdjusted
 * request should contain at least: { salePrice, loanType, LTV, MIP, FHA: { thresholds... } }
 * Returns { amount?, adjusted }
 */
export function calculateAdjusted(request = {}) {
  //console.log('calculateAdjusted called with request:', request);
  const safeNum = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const salePrice = safeNum(request.salePrice);
  if (salePrice <= 0) return { amount: 0, adjusted: 0 };

  const amount1 = safeNum(request.amount);
  const amount2 = safeNum(request.amount2);

  // DO NOT use safeNum on boolean-like flags
  const allowOwnerCarry1 = request.allowOwnerCarry1Check === true || request.allowOwnerCarry1Check === 1;
  const allowOwnerCarry2 = request.allowOwnerCarry2Check === true || request.allowOwnerCarry2Check === 1;

  const loanType = (request.loanType || "").toLowerCase();

  let amount = 0.00;
  let adjusted = 0.00;

  // -------------------------
  // VA Loan
  // -------------------------
  if (loanType.includes("va")) {
    const LTV = safeNum(request.LTV);

    amount = (LTV / 2) * salePrice / 100;
    adjusted = (LTV * salePrice) / 100 + salePrice;

    return {
      amount: amount.toFixed(2),
      adjusted: adjusted.toFixed(2)
    };
  }

  // -------------------------
  // USDA Loan
  // -------------------------
  if (loanType.includes("usda")) {
    const MIP = safeNum(request.MIP);

    adjusted = salePrice * MIP + salePrice;

    return {
      amount: "0.00",
      adjusted: adjusted.toFixed(2)
    };
  }

  // -------------------------
  // Conventional Loan
  // -------------------------
  if (loanType.includes("conventional")) {
    const LTV = safeNum(request.LTV);
    const MIP = safeNum(request.MIP);

    amount = (salePrice * LTV) / 100;
    adjusted = amount + (amount * MIP) / 100;

    return {
      amount: amount.toFixed(2),
      adjusted: adjusted.toFixed(2)
    };
  }

  // -------------------------
  // FHA Loan
  // -------------------------
  if (loanType.includes("fha")) {
    const FHA = request.FHA || {};

    let LTV = safeNum(FHA.FHA_SalePriceToLTV);

    try {
      const under = safeNum(FHA.FHA_SalePriceUnder);
      const underLTV = safeNum(FHA.FHA_SalePriceUnderLTV);

      const to = safeNum(FHA.FHA_SalePriceTo);
      const toLTV = safeNum(FHA.FHA_SalePriceToLTV);

      const over = safeNum(FHA.FHA_SalePriceOver);
      const overLTV = safeNum(FHA.FHA_SalePriceOverLTV);

      if (salePrice <= under) LTV = underLTV;
      else if (salePrice > under && salePrice <= to) LTV = toLTV;
      else if (salePrice > over) LTV = overLTV;
    } catch (e) {
      // ignore and fallback to default
    }

    const MIP = safeNum(request.MIP);

    amount = (salePrice * LTV) / 100;
    adjusted = amount + (amount * MIP) / 100;

    return {
      amount: amount.toFixed(2),
      adjusted: adjusted.toFixed(2)
    };
  }

  // -------------------------
  // Cash Purchase
  // -------------------------
  if (loanType.includes("cash")) {
    amount = salePrice;
    adjusted = 0.00;

    return {
      amount: amount.toFixed(2),
      adjusted: adjusted.toFixed(2)
    };
  }

  // -------------------------
  // Owner Carry
  // -------------------------
  if (loanType.includes("owner carry")) {

    amount = salePrice;

    if (allowOwnerCarry2) {
      adjusted = amount2;
    } else if (allowOwnerCarry1) {
      adjusted = amount1;
    }

    return {
      amount: amount.toFixed(2),
      adjusted: adjusted.toFixed(2)
    };
  }

  // Default fallback
  return { amount: 0.00, adjusted: 0.00 };
}
